<div class="absolute h-screen w-screen">
	<nz-spin
		*ngrxLet="globalLoading$ as globalLoading"
		nzSize="large"
		class="globalLoader h-full w-full"
		[nzSpinning]="globalLoading"
	>
		<router-outlet />
	</nz-spin>
</div>
